import React from "react";

const SvgDownload = (props: React.SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 40 40" fill="none" {...props}>
		<path
			d="M19.018 26.863c.26.265.612.416.982.416s.722-.151.982-.416l7.61-7.8a1.451 1.451 0 0 0 0-2.007 1.376 1.376 0 0 0-1.962 0l-5.241 5.377V7.42C21.389 6.644 20.778 6 20 6s-1.389.644-1.389 1.42v15.013l-5.24-5.377a1.376 1.376 0 0 0-1.964 0 1.451 1.451 0 0 0 0 2.007l7.611 7.8zm8.593 4.297H12.39c-.76 0-1.389.625-1.389 1.42 0 .795.63 1.42 1.389 1.42H27.61c.76 0 1.389-.644 1.389-1.42 0-.776-.611-1.42-1.389-1.42z"
			fill="currentColor"
		/>
	</svg>
);

export default SvgDownload;
